import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadGames, loading } from "../actions/gamesAction";
// ? Components
import Game from "../components/Game";
import { CircularProgress } from "@material-ui/core";
import JumboSvg from "../img/jumbo.svg";
import { Logo } from "../img/logo.svg";
import Jumbotron from "../components/Jumbotron";
import jumboImg from "../img/jumbo-img-2.jpg";
import { Container } from "react-bootstrap";
// ? Style
import styled from "styled-components";
import { motion } from "framer-motion";

function Home() {
  // ? Get data from state
  const { popular, newGames, upcoming, isLoading } = useSelector(
    (state) => state.games
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (!popular || !newGames || !upcoming) {
      return dispatch(loading());
    }
    dispatch(loadGames(9));
  }, []);

  // ? Jumbotron props
  const jumboProps = {
    image: jumboImg,
    text: "Find the latest information about the games.",
  };
  return (
    <>
      {isLoading && (
        <Loader>
          <CircularProgress color="inherit" size="8rem" />
        </Loader>
      )}
      {!isLoading && (
        <>
          <Jumbotron image={jumboProps.image} text={jumboProps.text} />
          <GameList>
            <h2>Upcoming Games</h2>
            <Games>
              {upcoming.map((game) => (
                <Game game={game} key={game.id} />
              ))}
            </Games>

            <h2>New Games</h2>
            <Games>
              {newGames.map((game) => (
                <Game game={game} key={game.id} />
              ))}
            </Games>

            <h2>Popular Games</h2>
            <Games>
              {popular.map((game) => (
                <Game game={game} key={game.id} />
              ))}
            </Games>
          </GameList>
        </>
      )}
    </>
  );
}

// ? Style

const GameList = styled(motion.div)`
  padding: 0rem 5rem;
  h2 {
    padding: 5rem 0rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0rem 2rem;
  }
`;

const Games = styled(motion.div)`
  min-height: 80vh;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  grid-column-gap: 2rem;
  grid-row-gap: 4rem;
  place-items: center;
  @media screen and (max-width: 768px) {
    place-items: initial;
    img {
      width: 80vw;
    }
    div {
      width: 80vw;
    }
  }
`;
const Loader = styled(motion.div)`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export default Home;
